import { render, staticRenderFns } from "./ClearTranslationWarning.vue?vue&type=template&id=75b1b4e8&"
import script from "./ClearTranslationWarning.vue?vue&type=script&lang=ts&"
export * from "./ClearTranslationWarning.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports